// src/features/executive/sales/payment-method-mix.utils.ts
// Display helpers for PaymentMethodMixCard — thin aliases over the shared
// master-slice helpers so the card reads in its own vocabulary.
import { masterSliceColor, masterSliceLabel, OTHER_SLICE_COLOR, OTHER_SLICE_KEY } from 'features/executive/shared/utils/master-slice'
import type { PaymentMethodItem } from 'api/executive/executive.types'

export const OTHER_METHOD_KEY = OTHER_SLICE_KEY
export const OTHER_METHOD_COLOR = OTHER_SLICE_COLOR

export function paymentMethodLabel(item: Pick<PaymentMethodItem, 'label' | 'labelEn'>, language: string | undefined): string {
  return masterSliceLabel(item, language)
}

export function paymentMethodColor(item: Pick<PaymentMethodItem, 'key'>, position: number): string {
  return masterSliceColor(item, position)
}
